import React, { useState, useEffect } from 'react';
import { useChatHistory, useMessages } from 'react-chatbotify';
import { useTranslation } from 'react-i18next';
import MemoryIcon from '@mui/icons-material/Memory';
import styles from './ButtonsStyles.module.scss';
import { botAiProvider } from '../ChatBotAI';

export const ForgetMemoryBotButton = () => {
  const { t } = useTranslation();
  const { setHistoryMessages } = useChatHistory();
  const { replaceMessages, injectMessage } = useMessages();
  const [busy, setBusy] = useState(false);
  const [canForget, setCanForget] = useState(() => botAiProvider.canForgetMemory);

  useEffect(() => {
    const updateCanForget = () => {
      setCanForget(botAiProvider.canForgetMemory);
    };

    const unsubscribe = botAiProvider.subscribe(updateCanForget);

    return unsubscribe;
  }, []);

  const disabled = busy || !canForget;

  const onClick = async () => {
    if (disabled) return;
    try {
      setBusy(true);
      const response = await botAiProvider.forgetMemory();
      await injectMessage(response.message, 'bot');

      if (response.success) {
        setTimeout(() => {
          setHistoryMessages([]);
          replaceMessages([]);
        }, 2000);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={onClick}
      className={`${styles.ForgetMemoryBotButton} rcb-attach-button-${disabled ? 'disabled' : 'enabled'}`}
      title={t('cartAI.forgetMemory') as string}
      disabled={disabled}
    >
      <MemoryIcon />
    </button>
  );
};
